import { MemberTypeEnum } from '../../enums/member-type.enum';
import { ICloneAndCopy } from '../../interfaces/clone-and-copy';

export class MagicStructureMember implements ICloneAndCopy {
    // Properties.
    public memberType: MemberTypeEnum;
    public member: string;

    public displayName: string;

    // Method to create example memebers.
    public static createExampleMembers(): MagicStructureMember[] {
        let exampleMembers: MagicStructureMember[] = [];

        let exampleMember: MagicStructureMember = new MagicStructureMember();
        exampleMember.memberType = MemberTypeEnum.GROUP;
        exampleMember.member = 'AGY-DOE';
        exampleMember.displayName = exampleMember.member;
        exampleMembers.push(exampleMember);

        exampleMember = new MagicStructureMember();
        exampleMember.memberType = MemberTypeEnum.GROUP;
        exampleMember.member = 'AGY-DOC';
        exampleMember.displayName = exampleMember.member;
        exampleMembers.push(exampleMember);

        return exampleMembers;
    }

    // ICloneAndCopy Methods.
    public clone(): ICloneAndCopy {
        let clone: MagicStructureMember = new MagicStructureMember();
        clone.copy(this);

        return clone;
    }

    public copy(objectToCopy: ICloneAndCopy): void {
        let memberToCopy: MagicStructureMember = <MagicStructureMember>objectToCopy;

        this.memberType = memberToCopy.memberType;
        this.member = memberToCopy.member;
        this.displayName = memberToCopy.displayName;
    }
}
